import api from './api';

export default {
    index(search=false,sort=false,page=1 , isUser=false){
        return api.get(`${process.env.VUE_APP_URL}/roles` , {params: {search:search , sort:sort , page:page ,  isUser:isUser}});
    },
    create(params){
        return api.post(`${process.env.VUE_APP_URL}/roles` , params);
    },
    show(id){
        return api.get(`${process.env.VUE_APP_URL}/roles/${id}`);
    },
    update(id , params){
        return api.put(`${process.env.VUE_APP_URL}/roles/${id}` , params);
    },
    delete(id){
        return api.delete(`${process.env.VUE_APP_URL}/roles/${id}`);
    },
    getPermissions(type){
        return api.get(`${process.env.VUE_APP_URL}/get/permissions/${type}`);
    }
}